import { Mousetrap } from './Mousetrap';

export const mousetrap = new Mousetrap(document);
